/*
 *
 * MsTeamsVerify actions
 *
 */

import { VERIFY_MSTEAMS } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifyMsteams = {
  start: ({ payload, metadata }) => defineAction({ type: VERIFY_MSTEAMS.START, payload, metadata }),
  success: () => {
    return defineAction({ type: VERIFY_MSTEAMS.SUCCESS });
  },
  error: ({ error }) =>
    defineAction({
      type: VERIFY_MSTEAMS.ERROR,
      payload: {
        error,
      },
    }),
};
